// material
import { styled } from '@mui/material/styles';
// components
import Page from '../../../components/Page';
import {
  AboutCards,
  AboutHero,
  AboutHeroInPage,
  AboutAlianzas,
  AboutHeroInPageBlack,
  HomeLandingCardPost,
  AboutTextHoverImage,
  AboutVideo
} from './components';
import { HomeFooter } from '../home/components';
import { Stack } from '@mui/material';

// ----------------------------------------------------------------------

const RootStyle = styled(Page)(({ theme }) => ({
  height: '100%'
}));

const ContentStyle = styled('div')(({ theme }) => ({
  overflow: 'hidden',
  position: 'relative',
  backgroundColor: theme.palette.background.default
}));

// ----------------------------------------------------------------------

export default function RefiereYGana() {
  return (
    <RootStyle title="Iban | Nosotros" id="move_top">
      <AboutHero />
      <ContentStyle>
        <Stack spacing={10}>
          <AboutCards />
          <AboutVideo />
          <AboutAlianzas />
          <AboutTextHoverImage />
          <AboutHeroInPageBlack />
          <AboutHeroInPage />
          <HomeLandingCardPost />
          <HomeFooter />
        </Stack>
      </ContentStyle>
    </RootStyle>
  );
}
